// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__KsCvy","file":"styles_file__3DmJN"};